import axiosInstance from '../axiosInterceptor/axiosInstance'

const bulkCreateGamedays = async ({ orgId, data }) => {
  const url = `v1/orgs/${orgId}/gamedays/bulk`
  const response = await axiosInstance.post(url, data)
  return response?.data
}

export default bulkCreateGamedays
